import { createContext } from "react"

const QuoteComparisonContext = createContext({})

const { Provider, Consumer } = QuoteComparisonContext

export { Provider, Consumer, QuoteComparisonContext }
